import React from "react";
export const CheckIcon = ({ className, dataType }) => {
    return (React.createElement("svg", { className: className, "data-type": dataType, fill: 'none', height: '24', viewBox: '0 0 24 24', width: '24', xmlns: 'http://www.w3.org/2000/svg' },
        React.createElement("path", { clipRule: 'evenodd', d: 'm18 9-7 7c-.3.3-.7.3-1 0l-4-4 1-1 3.5 3.4L17 8l1 1Z', fill: 'var(--black)', fillRule: 'evenodd' })));
};
